var path = 'app/scripts/modules/google/src/serverGroup/configure/wizard/loadBalancers/loadBalancers.html';
var html = "<ng-form name=\"loadBalancerSubForm\">\n  <div>\n    <gce-server-group-load-balancer-selector command=\"command\"></gce-server-group-load-balancer-selector>\n  </div>\n</ng-form>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/google/src/serverGroup/configure/wizard/loadBalancers/loadBalancers.html
// module id = 1354
// module chunks = 0